import { t } from '@shared/i18n';
import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="container narrow" style={{ padding: '80px 16px', textAlign: 'center' }}>
      <h1>{t('Page introuvable', 'Page not found')}</h1>
      <p className="muted">
        {t("Cette adresse n'existe pas (ou plus).", 'This address does not exist (or no longer exists).')}
      </p>
      <Link to="/" className="btn">
        {t("Retour à l'accueil", 'Back to home')}
      </Link>
    </div>
  );
}
